<template>
    <b-form-group
        v-if="monthOptions[0]"
        class="b-form-group-flatpickr-custom"
    >
        <b-input-group
            :size="size"
        >
            <flat-pickr
                ref="REF_CALENDAR_MONTH_RANGE"
                v-model="monthRangeModel"
                class="form-control create-form-flatpicker border-right-0"
                :config="getDatePickConfig"
                placeholder="YYYY-MM ~ YYYY-MM"
            />
            <b-input-group-prepend
                is-text
                class="cursor-pointer"
                @click="openCalendar"
            >
                <SVGCalendarNumberIcon/>
            </b-input-group-prepend>
        </b-input-group>
    </b-form-group>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import MonthSelectPlugin from '@/libs/monthSelect'
import { getCurrentInstance, ref, toRefs, computed, watch } from '@vue/composition-api'
import useSelectMonthRange from '@/composables/useSelectMonthRange'
import useDatepickConfig from '@/composables/useDatepickConfig'
import moment from 'moment'
import SVGCalendarNumberIcon from '@/assets/images/icons/calendar-with-number.svg'

export default {
    components: {
        flatPickr,
        SVGCalendarNumberIcon
    },
    props: ['storeKey', 'size'],
    setup (props, context) {
        const vm = getCurrentInstance().proxy
        const REF_CALENDAR_MONTH_RANGE = ref(null)
        const { storeKey } = toRefs(props)
        const {
            monthRangeModel,
            selectedMonthRange,
            monthOptions,
            minDate,
            maxDate,
            selectMonthRange,
            handleSelectMonthRange
        } = useSelectMonthRange(storeKey.value)
        const {
            datePickConfig,
            buttons,
            dateShortAndLonghand
        } = useDatepickConfig()
        const getDatePickConfig = computed(() => {
            const tmpConfig = {
                ...datePickConfig.value,
                locale: {
                    ...dateShortAndLonghand.value,
                    ...buttons.value,
                    rangeSeparator: ' ~ '
                }
            }
            return tmpConfig
        })
        const openCalendar = () => {
            vm.$nextTick(() => {
                if (REF_CALENDAR_MONTH_RANGE.value) {
                    REF_CALENDAR_MONTH_RANGE.value.fp.open()
                }
            })
        }
        const duration = moment.duration({ 'months': -1 })
        const setFpInstance = () => {
            if (!minDate || !maxDate) return
            const monthRangeArr = []
            const min = moment(monthOptions.value[0], 'YYYY-MM')
            let date = moment(monthOptions.value[1], 'YYYY-MM')
            for (let i = 0; i < 3 && min <= date; i++) {
                monthRangeArr.unshift(date.format('YYYY-MM'))
                date = date.add(duration)
            }
            monthRangeModel.value = `${monthRangeArr[0]} ~ ${monthRangeArr[monthRangeArr.length - 1]}`
            selectMonthRange(monthRangeArr)
            datePickConfig.value = {
                mode: 'range',
                wrap: true,
                allowInput: false,
                closeOnSelect: false,
                minDate: monthOptions.value[0],
                maxDate: monthOptions.value[1],
                plugins: [
                    new MonthSelectPlugin({
                        shorthand: true,
                        dateFormat: 'Y-m',
                        shortcutButtons: {
                            show: true,
                            events: {
                                handleConfirm: handleSelectMonthRange
                            }
                        }
                    })
                ]
            }
        }
        watch(selectedMonthRange, (value, oldValue) => {
            monthRangeModel.value = `${value[0]} ~ ${value[value.length - 1]}`
        }, {
            deep: true
        })
        watch([minDate, maxDate], (value, oldValue) => {
            setFpInstance()
        }, {
            deep: true,
            immediate: true
        })
        return {
            REF_CALENDAR_MONTH_RANGE,
            monthOptions,
            datePickConfig,
            monthRangeModel,
            selectedMonthRange,
            getDatePickConfig,
            openCalendar
        }
    }
}
</script>
